import queryString from 'query-string';
import RequestArticleGroupCountryTax from 'src/adminPanel/entities/articleManagement/RequestArticleGroupCountryTax';
import callApi, { CallApiResult } from '.';

export const getArticleGroupCountryTax = (articleTypeId: string, articleGroupId: string): Promise<CallApiResult> => {
    let query = queryString.stringify({ articleTypeId, articleGroupId }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    return callApi(`/api/articleGroupCountryTax/list${query}`);
};

export const createNewArticleGroupCountryTax = (
    articleGroupCountryTaxRequestDto: RequestArticleGroupCountryTax
): Promise<CallApiResult> => {
    return callApi(`/api/articleGroupCountryTax/add`, { method: 'POST', data: articleGroupCountryTaxRequestDto });
};

export const updateArticleGroupCountryTax = (
    articleGroupCountryTaxRequestDto: RequestArticleGroupCountryTax
): Promise<CallApiResult> => {
    return callApi(`/api/articleGroupCountryTax/update`, { method: 'PUT', data: articleGroupCountryTaxRequestDto });
};

export const deleteArticleGroupCountryTax = (articleGroupCountryTaxId: string): Promise<CallApiResult> => {
    return callApi(`/api/articleGroupCountryTax/delete/${articleGroupCountryTaxId}`, { method: 'DELETE' });
};
